module.exports = __webpack_public_path__ + "static/img/ikona_cw4-OFF.099437b3.png";